import config from '../../config.js'

const Storage = {
    getItem: (name) =>
        localStorage.getItem(config.storagePrefix + name),

    setItem: (name, value) =>
        localStorage.setItem(config.storagePrefix + name, value),

    removeItem: (name) =>
        localStorage.removeItem(config.storagePrefix + name),

}


export default Storage;